/** Shared vocabulary for the recurring-billing screens. */

export const FREQUENCIES = [
  ["daily", "Daily"],
  ["weekly", "Weekly"],
  ["fortnightly", "Fortnightly"],
  ["monthly", "Monthly"],
  ["quarterly", "Quarterly"],
  ["yearly", "Yearly"],
  ["one_time", "One time"],
] as const;

export const SCHEDULE_STATUS_TONE: Record<
  string,
  "emerald" | "amber" | "rose" | "slate" | "sky"
> = {
  active: "emerald",
  paused: "amber",
  cancelled: "rose",
  completed: "sky",
};

export const SCHEDULE_FILTERS = ["", "active", "paused", "cancelled", "completed"] as const;
